import { useTranslation } from 'react-i18next';

import { Button, Heading, Paragraph } from '@app/shared/ui/atoms/Common';

interface TextBannerProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onBtnClick?: () => void;
}

export function TextBanner({ title, description, buttonText, onBtnClick }: TextBannerProps) {
  const { t } = useTranslation();

  return (
    <>
      <div>
        {title && (
          <Heading level={4} className="text-foreground text-shadow-dark">
            {t(title)}
          </Heading>
        )}

        {description && (
          <Paragraph variant="white" className="whitespace-pre-line text-shadow-dark">
            {t(description)}
          </Paragraph>
        )}
      </div>

      {buttonText && (
        <Button className="px-2" shadow="cyan" onClick={onBtnClick}>
          {t(buttonText)}
        </Button>
      )}
    </>
  );
}
